import React, {Component} from 'react';
import {connect} from 'react-redux';
import NumberHelper from 'helpers/number-helper';
import Action from 'components/organisms/non-controlled-hitter-stacking/actions';

class CombinationExposure extends Component {
    constructor(props) {
        super(props);
        const {stacking, comboKey} = props;
        this.isValueBeingChanged = false;
        this.state = {
            value: stacking.getCombinationExposure(comboKey),
        };
    }

    onChange(value) {
        this.isValueBeingChanged = true;
        this.setState({value});
    }

    onBlur(value) {
        const exposure = this.normalizeExposures(value);

        this.setState({value: exposure});

        this.isValueBeingChanged = false;

        this.props.dispatch(Action.setCombinationExposure(this.props.comboKey, exposure));
    }

    normalizeExposures(value) {
        return NumberHelper.prepareInt(value, 0).limitByRange(0, 100, 0, 100).get();
    }

    getActualValue() {
        let value = this.state.value;
        if (!this.isValueBeingChanged) {
            const {comboKey, stacking} = this.props;
            value = stacking.getCombinationExposure(comboKey);
        }
        return value;
    }

    render() {
        const {className = 'form-control'} = this.props;
        const exposure = this.getActualValue();

        return (
            <input
                onBlur={(e) => ::this.onBlur(e.target.value)}
                onChange={(e) => ::this.onChange(e.target.value)}
                value={`${exposure}`}
                type="number"
                className={className}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {nonControlledHitterStacking} = state;
    return {
        stacking: nonControlledHitterStacking.settings,
    };
}

export default connect(mapStatesToProps)(CombinationExposure);
